import { Vue, Component } from 'vue-property-decorator';
import { ITextValuePair, IReportSchedule } from '@/Interfaces';
import { LSReportSource } from '@/Sources';
import { SchedulerType, IDomainReportFolderItem } from '@samc/querybuilder';
import { ReportScheduleDataSource } from './DataSources/ReportScheduleDataSource';
import { IEditDeleteButtonsRendererOnClickParams, Grid, FormButtonDisabler, IEditDeleteButtonsRendererCallbackParams, CellDoubleClickedEvent } from '@samc/centricity-core';

import '@/registerVuePlugins';
import { AjaxHelper } from '@samc/common';

@Component({
  name: 'ReportingScheduledExportsList',
  components: { Grid, FormButtonDisabler }
})
class ListComponent extends Vue {
  public verificationToken: string = '';
  public gridKey: number = 0;

  /**
   * The set of frequecies that are allowed for the scheduled import
   */
  public frequencies: ITextValuePair<SchedulerType>[] = [
    { text: 'Hourly', value: 'hourly' },
    { text: 'Daily', value: 'daily' },
    { text: 'Weekly', value: 'weekly' },
    { text: 'Monthly', value: 'monthly' }
  ];
  public statuses: ITextValuePair<string>[] = [
    { text: 'Initialized', value: 'Initialized' },
    { text: 'Enabled', value: 'Enabled' },
    { text: 'Paused', value: 'Paused' },
    { text: 'Error', value: 'Error' },
    { text: 'ScheduleConfigError', value: 'ScheduleConfigError' },
    { text: 'SchedulerError', value: 'SchedulerError' }
  ];

  public reports: IDomainReportFolderItem[] | LSReportSource = [];
  public dataSource: null | ReportScheduleDataSource = null;

  public async mounted() {
    this.verificationToken = await this.$verificationToken();

    this.reports = new LSReportSource();
    this.dataSource = new ReportScheduleDataSource(this.verificationToken);
  }

  /**
   * Helper method is meant to be called when ag-grid double clicks on an item
   * 
   * @param e The event that is processed when this happens
   */
  public onRowDoubleClick(e: CellDoubleClickedEvent<IReportSchedule>) {
    window.location.href = `/Reporting/ScheduledExports/Edit?id=${e.data?.id}`;
  }

  public onEditScheduleClick(e: IEditDeleteButtonsRendererOnClickParams<IReportSchedule>) {
    window.location.href = `/Reporting/ScheduledExports/Edit?id=${e.data.id}`;
  }

  public getIcon(data: IReportSchedule) {
    return data.isActive ? 'icon-pause' : 'icon-run'
  }

  public async onToggleEnableClick(e: IEditDeleteButtonsRendererOnClickParams<IReportSchedule>) {
    try {
      const model = e.data;

      this.$loading(model.isActive ? 'Pausing Scheduled Export' : 'Resuming Scheduled Export');
      model.isActive = !model.isActive;
      const helper = new AjaxHelper(`/componentapi/reportschedule/${e.data.id}/toggleactive`, this.verificationToken, null, null);

      await helper.postData('', {});
      this.gridKey++;
    } finally {
      this.$loading();
    }
  }
}

new ListComponent()
  .$mount('#scheduled-exports-list-view');